import getRequest from '@/api'

const request = getRequest(process.env.VUE_APP_QUALITY_API, 'data')

/**
 * 获取质检员列表
 */
export const getInspectorList = data => {
  return request.post('tenantStaff/list', data)
}

/**
 * 获取质检单列表
 */
export function getInspectionOrderList(data) {
  return request.post('inspectionOrder/page', data)
}

/**
 * 删除质检单
 */
export function deleteInspectionOrder(id) {
  return request.delete(`inspectionOrder/${id}`)
}

/**
 * 指定质检员
 */
export function assignInspector(data) {
  return request.post('inspectionOrder/updateQc', data)
}

/**
 * 修改验货/验厂订单标准
 */
export function modifyInspectionStandard(data) {
  return request.post('inspectionOrder/updateConfig', data)
}

/**
 * 重验
 */
export function resetOrder(data) {
  return request.post(`inspectionOrder/retest`, data)
}

/**
 * 获取质检报告详情
 */
export function getReportDetail(data) {
  return request.post(`inspectionOrder/getReport`, data)
}

/**
 * 获取历史质检报告详情
 */
export function getHistoryReportDetail(id) {
  return request.get(`inspectionOrderRetestHistory/${id}`)
}

/**
 * 获取疵点质检报告详情
 */
export function getHistoryDefectReportDetail(id) {
  return request.get(`inspectionOrderDefectiveReport/getReportByDefectiveReportNo/${id}`)
}

/**
 * 下载质检报告
 */
export function downloadReport(data) {
  return request.get(`inspectionOrder/export`, data, {
    responseType: 'blob',
    disableHandle: true
  })
}

/**
 * 下载疵点质检报告
 */
export function downloadDefectReport(data) {
  return request.get(`inspectionOrderDefectiveReport/export`, data, {
    responseType: 'blob',
    disableHandle: true
  })
}

/**
 * 获取历史报告列表
 */
export function getHistoryReportList(data) {
  return request.post(`inspectionOrderRetestHistory/page`, data)
}

/**
 * 获取历史疵点报告列表
 */
export function getHistoryDefectReportList(id) {
  return request.get(`inspectionOrderDefectiveReport/getListByInspectionOrderId/${id}`)
}

/**
 * 审核通过
 */
export function auditPass(data) {
  return request.post(`inspectionOrder/review`, data)
}

/**
 * 审核驳回
 */
export function auditReject(data) {
  return request.post(`inspectionOrder/reject`, data)
}

/**
 * 获取是否需要审核
 */
export function getIsReviewInspection(bizType) {
  return request.get(`commonConfig/getByBizType/${bizType}`)
}

/**
 * 是否过期
 */
export function isExpired() {
  return request.get(`verifyTenantEffectiveDate`)
}